<template v-show="$parent.isModalVisible" lang="pug">
div.h-100(name='modal')
  .modal-mask.h-100(v-on:mousedown.self="$emit('close')")
    transition(name='slide-fade')
      .modal-container.col-6.h-100(v-if='$parent.isModalVisible')
        .modal-header
          slot(name='header')
            h2 Новый клиент
          span.btn-close.btn-right.border-0.bg-transparent.text-center(type='button' v-on:click='$parent.closeModal' aria-label='Close modal' style='padding:5px 10px;cursor:pointer;')
            i.fas.fa-times
        div(v-bind:class="['modal-body', {'h-75': $parent.showScript > 0}]")
          slot(name='body')
        div(v-bind:class="['modal-footer', {'d-none': $parent.showScript > 0}]")
          slot(name='footer')
</template>
<script>/* eslint-disable */
  export default {
    data () {
      return {
      }
    },
    mounted() {
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modal.vue